import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2, FileText } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function SEPAMandate() {
  const { user } = useAuth();
  const [form, setForm] = useState({ iban: '', bic: '', titulaire: '', adresse_titulaire: '' });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!form.iban || !form.titulaire || !form.adresse_titulaire) { toast.error('Champs obligatoires'); return; }
    setSaving(true);
    try {
      await axios.post(`${API_URL}/sepa/mandate`, { ...form, structure_id: user?.structure_id });
      toast.success('Mandat SEPA créé');
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-center"><FileText className="w-6 h-6 inline mr-2" />Mandat SEPA</h1>
      <Card>
        <CardHeader><CardTitle>Informations bancaires</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div><Label>IBAN *</Label><Input value={form.iban} onChange={e => setForm({...form, iban: e.target.value})} placeholder="FR76 XXXX XXXX XXXX XXXX XXXX XXX" /></div>
          <div><Label>BIC</Label><Input value={form.bic} onChange={e => setForm({...form, bic: e.target.value})} placeholder="BNPAFRPP" /></div>
          <div><Label>Titulaire du compte *</Label><Input value={form.titulaire} onChange={e => setForm({...form, titulaire: e.target.value})} /></div>
          <div><Label>Adresse du titulaire *</Label><Input value={form.adresse_titulaire} onChange={e => setForm({...form, adresse_titulaire: e.target.value})} /></div>
          <Button onClick={handleSubmit} disabled={saving} className="w-full bg-[#0F5156] hover:bg-[#0d464a]">{saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Signer le mandat SEPA</Button>
        </CardContent>
      </Card>
    </div>
  );
}
